"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kelvinToFahrenheit = void 0;
// convert kelvin to fahrenheit
const kelvinToFahrenheit = (kelvin) => {
    return `${Math.round((kelvin - 273.15) * 1.8 + 32)}°F`;
};
exports.kelvinToFahrenheit = kelvinToFahrenheit;
